import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AcademicCapIcon } from '@heroicons/react/24/outline';
import Button from './Button';

const Footer = ({ 
  showBottomBar = true, 
  className = '',
  variant = 'default' 
}) => {
  const [imageError, setImageError] = useState(false);
  
  const baseClasses = variant === 'minimal' 
    ? 'bg-gray-900 text-white py-8' 
    : 'bg-gray-900 text-white py-12';

  const classes = `${baseClasses} ${className}`;

  return (
    <footer className={classes}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Company Info */}
          <div className="flex items-center">
            {!imageError ? (
              <img 
                src="/images/aitech-light.png" 
                alt="Aitech Logo" 
                className="h-10 w-auto"
                onError={() => setImageError(true)}
              />
            ) : (
              <div className="flex items-center">
                <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-r from-primary-600 to-primary-700 rounded-xl mr-3">
                  <AcademicCapIcon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">AITECH</h3>
                  <p className="text-sm text-gray-400">Technologies Nigeria</p>
                </div>
              </div>
            )}
          </div>

          {/* Contact Info & CTA */}
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
            <a 
              href="mailto:info@aitechnologiesng.com" 
              className="text-gray-300 hover:text-primary-400 transition-colors text-sm"
            >
              info@aitechnologiesng.com
            </a>
            
            <div className="flex flex-col md:flex-row md:space-x-4">
              <a 
                href="tel:+2348142100460" 
                className="text-gray-300 hover:text-primary-400 transition-colors text-sm"
              >
                +234 814 210 0460
              </a>
              <a 
                href="tel:+2348123181756" 
                className="text-gray-300 hover:text-primary-400 transition-colors text-sm"
              >
                +234 812 318 1756
              </a>
            </div>

            <Button 
              to="/login"
              variant="primary"
              size="sm"
            >
              Member Area
            </Button>
          </div>
        </div>

        {/* Bottom Bar */}
        {showBottomBar && (
          <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              &copy; 2024 Aitech Technologies Nigeria. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-primary-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-primary-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="hover:text-primary-400 transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer; 